import React, { useContext } from "react";

// components
import Content from "./Content";

// Global state
import { StateContext } from "../../AppStateContext";

const Main = ({ classes }) => {
  // Consume global state
  const state = useContext(StateContext);

  return (
    <main
      className={
        state.theme === "light" ? classes.content : classes.contentDark
      }
    >
      <div className={classes.toolbar} />
      <Content />
    </main>
  );
};

export default Main;
